import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";
import SanityImage from "../SanityImage";

const ImageUI = ({ input, showCaption = true }) => {
  const { image, caption, linkObject } = input;
  const hasLink = linkObject && linkObject.link !== null;
  // console.log(hasLink);
  return (
    <section className={clsx("imageUI section")}>
      <SanityImage input={{ image: image }} objectFit='cover' />
      {showCaption && (
        <figcaption className='absolute left-md bottom-md md:w-full text-sm-lg md:text-lg transition-opacity z-50'>
          {caption && <div>{caption}</div>}

          {hasLink && (
            <Link to={`/${linkObject.link.slug.current}`} className='em'>
              {linkObject.label}
            </Link>
          )}
        </figcaption>
      )}
    </section>
  );
};

export default ImageUI;
